(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_favicon"] && !Shopify.designMode) return;
  try {
    (() => {
    const icon = document.getElementById('paloma-favicon');
    if (!icon || !window.matchMedia) return;

    const preference = window.matchMedia('(prefers-color-scheme: dark)');
    const updateIcon = () => {
      const url = preference.matches ? icon.dataset.darkIcon : icon.dataset.lightIcon;
      if (icon.getAttribute('href') !== url) icon.setAttribute('href', url);
    };

    updateIcon();
    preference.addEventListener('change', updateIcon);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-submit-feedback"] && !Shopify.designMode) return;
  try {
    if (!window.palomaNativeSubmitFeedbackBound) {
    window.palomaNativeSubmitFeedbackBound = true;
    document.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      const form = event.target;
      const button = form.querySelector('[data-native-submit-feedback]');
      const label = button?.querySelector('.paloma-form-submit-label');
      if (!button || !label || !form.checkValidity()) return;
      button.dataset.initialLabel = label.textContent;
      label.textContent = button.dataset.sendingLabel;
      if (label.hasAttribute('data-label')) label.dataset.label = label.textContent;
      label.classList.remove('visually-hidden');
      const icon = button.querySelector('.field-submit__content');
      if (icon) icon.hidden = true;
      button.classList.add('paloma-form-submit--pending');
      button.disabled = true;
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      document.querySelectorAll('[data-native-submit-feedback].paloma-form-submit--pending').forEach(button => {
        const label = button.querySelector('.paloma-form-submit-label');
        label.textContent = button.dataset.initialLabel;
        if (label.hasAttribute('data-label')) label.dataset.label = label.textContent;
        const icon = button.querySelector('.field-submit__content');
        if (icon) { icon.hidden = false; label.classList.add('visually-hidden'); }
        button.classList.remove('paloma-form-submit--pending');
        button.disabled = false;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paloma-market-country')) {
    class PalomaMarketCountry extends HTMLElement {
      static detectedCountryPromise;

      connectedCallback() {
        this.applyDetectedCountry();
      }

      async applyDetectedCountry() {
        const availableCountries = (this.dataset.availableCountryCodes || '').split(',').filter(Boolean);

        try {
          PalomaMarketCountry.detectedCountryPromise ||= fetch(
            `${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true`,
            { headers: { Accept: 'application/json' } }
          )
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => data?.detected_values?.country?.handle?.toUpperCase() || null);

          const detectedCountry = await PalomaMarketCountry.detectedCountryPromise;
          if (!detectedCountry || !availableCountries.includes(detectedCountry)) return;

          const regionLinks = Array.from(this.querySelectorAll('[data-market-region]'));
          const matchingRegion =
            regionLinks.find((link) =>
              (link.dataset.regionCountries || '').split(',').filter(Boolean).includes(detectedCountry)
            ) || regionLinks.find((link) => link.dataset.marketRegion === 'rest-of-world');

          if (matchingRegion) {
            matchingRegion.dataset.value = detectedCountry;
            matchingRegion.dataset.detectedCountry = detectedCountry;
          }
        } catch (error) {
          // Keep the region's existing fallback country if Shopify's detection is unavailable.
        }
      }
    }

    customElements.define('paloma-market-country', PalomaMarketCountry);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paloma-mobile-showcase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paloma-mobile-showcase')) {
    customElements.define('paloma-mobile-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!this.tabs.includes(tab)) return;
          event.preventDefault();
          this.select(this.tabs.indexOf(tab));
        };
        this.onKeydown = (event) => {
          const tab = event.target.closest('[role="tab"]');
          const index = this.tabs.indexOf(tab);
          if (index !== -1) {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
            return;
          }
          if (!event.target.matches('.paloma-mobile-showcase--products .paloma-mobile-showcase__cards')) return;
          const track = event.target;
          const step = track.querySelector('li')?.getBoundingClientRect().width || track.clientWidth;
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth :
            track.scrollLeft + (event.key === 'ArrowRight' ? step + 1 : -step - 1);
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.onBlockSelect = (event) => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index !== -1) this.select(index);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.ready = false;
      }
      select(index) {
        if (!this.tabs[index] || !this.panels[index]) return;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-delivery-region"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-delivery-region')) {
    customElements.define(
      'product-delivery-region',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('button');
          this.buttons.forEach((button) => button.addEventListener('click', this.openRegionSelector));
        }

        disconnectedCallback() {
          this.buttons?.forEach((button) => button.removeEventListener('click', this.openRegionSelector));
        }

        openRegionSelector = (event) => {
          const isMobile = window.matchMedia('(max-width: 1160px)').matches;
          const headerToggle = document.querySelector(
            'modal-region-selector.header__region:not(.header__contact):not(.menu-drawer__utility-region) .modal-region-toggle'
          );
          const headerBounds = headerToggle?.getBoundingClientRect();
          const headerIsVisible =
            headerBounds &&
            headerBounds.width > 0 &&
            headerBounds.height > 0 &&
            headerBounds.top < window.innerHeight &&
            headerBounds.bottom > 0 &&
            headerBounds.left < window.innerWidth &&
            headerBounds.right > 0;
          const regionToggle = headerIsVisible && !isMobile
            ? headerToggle
            : document.querySelector('modal-region-selector.footer-modal .modal-region-toggle');

          if (isMobile && regionToggle) {
            regionToggle.closest('modal-region-selector').returnFocusTo = event.currentTarget;
          }
          regionToggle?.click();
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quote-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-quote-request')) {
    customElements.define('product-quote-request', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.modal = this.closest('modal-dialog');
        this.phoneCode = this.querySelector('[data-quote-phone-code]');
        this.controlsAbort = new AbortController();
        const controlsOptions = { signal: this.controlsAbort.signal };
        this.setupPhoneCode(controlsOptions);
        this.setupDetails(controlsOptions);
        this.shippingHelp = [...this.querySelectorAll('.product-quote__shipping-help')];
        this.shippingHelp.forEach(help => {
          help.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
            this.shippingHelp.forEach(other => { other.open = other === help; });
          }, controlsOptions);
          help.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) help.open = false;
          }, controlsOptions);
          help.querySelector('summary').addEventListener('click', event => {
            if (!event.detail || !window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
            event.preventDefault();
            help.open = true;
          }, controlsOptions);
          help.addEventListener('keydown', event => {
            if (event.key !== 'Escape' || !help.open) return;
            event.preventDefault();
            event.stopPropagation();
            help.open = false;
            help.querySelector('summary').focus();
          }, controlsOptions);
        });
        document.addEventListener('pointerdown', event => {
          if (!this.codePicker?.contains(event.target)) this.closePhoneCode();
          this.shippingHelp.forEach(help => { if (!help.contains(event.target)) help.open = false; });
        }, controlsOptions);
        this.phoneCode?.addEventListener('change', this.updatePhoneCode);
        this.updatePhoneCode();
        this.form.addEventListener('submit', this.submit);
        if (window.location.hash === `#${this.form.id}` && this.querySelector('[data-quote-success], [data-quote-error]:not([hidden])')) {
          requestAnimationFrame(() => this.modal.show());
        }
      }

      disconnectedCallback() {
        this.controlsAbort?.abort();
        this.detailsObserver?.disconnect();
        this.phoneCode?.removeEventListener('change', this.updatePhoneCode);
        this.form?.removeEventListener('submit', this.submit);
        this.initialized = false;
      }

      setupDetails(options) {
        this.detailsField = this.querySelector('.product-quote__textarea');
        this.detailsEntry = this.querySelector('.product-quote__details-entry');
        if (!this.detailsField || !this.detailsEntry) return;
        this.detailsWidth = null;
        this.detailsField.addEventListener('focus', this.resizeDetails, options);
        this.detailsEntry.addEventListener('click', event => {
          if (event.target === this.detailsEntry) this.detailsField.focus();
        }, options);
        this.detailsObserver = new ResizeObserver(this.resizeDetails);
        this.detailsObserver.observe(this.detailsEntry);
        this.resizeDetails();
      }

      resizeDetails = () => {
        if (!this.detailsField?.isConnected || !this.detailsField.offsetWidth) return;
        const width = this.detailsField.offsetWidth;
        if (width === this.detailsWidth) return;
        this.detailsWidth = width;
        const style = getComputedStyle(this.detailsField);
        const minimum = parseFloat(style.minHeight);
        const maximum = parseFloat(style.maxHeight);
        const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const measure = this.detailsField.cloneNode();
        measure.removeAttribute('id');
        measure.removeAttribute('name');
        measure.setAttribute('aria-hidden', 'true');
        measure.tabIndex = -1;
        measure.value = '';
        Object.assign(measure.style, { position: 'absolute', top: '0', left: '0', visibility: 'hidden', pointerEvents: 'none', width: `${width}px`, height: 'auto', minHeight: '0', maxHeight: 'none', transition: 'none' });
        this.detailsEntry.append(measure);
        const collapsedHeight = Math.max(minimum, Math.min(maximum, measure.scrollHeight + borders));
        measure.remove();
        this.detailsField.style.setProperty('--quote-details-collapsed-height', `${collapsedHeight}px`);
      };

      updatePhoneCode = () => {
        const selected = this.phoneCode?.selectedOptions[0]?.textContent.trim() || '';
        this.querySelectorAll('[data-quote-phone-code-label]').forEach(label => { label.textContent = selected; });
        this.codeOptions?.forEach(option => option.setAttribute('aria-selected', String(option.dataset.value === this.phoneCode.value)));
      };

      setupPhoneCode(options) {
        this.codePicker = this.querySelector('[data-quote-code-picker]');
        this.codeTrigger = this.querySelector('[data-quote-code-trigger]');
        this.codeList = this.querySelector('[data-quote-code-list]');
        if (!this.phoneCode || !this.codeTrigger || !this.codeList) return;
        this.codeOptions = [...this.phoneCode.options].filter(option => option.value && !option.disabled).map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-quote__code-option';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', String(option.selected));
          button.tabIndex = -1;
          button.dataset.value = option.value;
          button.textContent = option.textContent;
          button.addEventListener('click', () => {
            this.phoneCode.value = button.dataset.value;
            this.phoneCode.dispatchEvent(new Event('change', { bubbles: true }));
            this.closePhoneCode(true);
          }, options);
          return button;
        });
        this.codeList.replaceChildren(...this.codeOptions);
        this.phoneCode.tabIndex = -1;
        this.phoneCode.setAttribute('aria-hidden', 'true');
        this.codePicker.classList.add('is-enhanced');
        this.codeTrigger.hidden = false;
        this.codeTrigger.addEventListener('click', () => {
          if (this.codeList.hidden) this.openPhoneCode();
          else this.closePhoneCode();
        }, options);
        this.phoneCode.addEventListener('invalid', event => {
          event.preventDefault();
          this.codeTrigger.focus();
          this.openPhoneCode();
        }, options);
        this.codePicker.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.codeList.hidden) {
            event.preventDefault();
            event.stopPropagation();
            this.closePhoneCode(true);
          } else if (event.key === 'Tab') {
            this.closePhoneCode();
          } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            if (this.codeList.hidden) return this.openPhoneCode();
            const current = this.codeOptions.indexOf(document.activeElement);
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.codeOptions.length - 1 : Math.max(0, Math.min(this.codeOptions.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
            this.codeOptions[next]?.focus({ preventScroll: true });
            this.codeOptions[next]?.scrollIntoView({ block: 'nearest' });
          }
        }, options);
      }

      openPhoneCode() {
        if (!this.codeList) return;
        this.codeList.hidden = false;
        this.codeTrigger.setAttribute('aria-expanded', 'true');
        const selected = this.codeOptions.find(option => option.dataset.value === this.phoneCode.value) || this.codeOptions[0];
        selected?.focus({ preventScroll: true });
        selected?.scrollIntoView({ block: 'nearest' });
      }

      closePhoneCode(restoreFocus = false) {
        if (!this.codeList) return;
        this.codeList.hidden = true;
        this.codeTrigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.codeTrigger.focus({ preventScroll: true });
      }

      submit = async (event) => {
        event.preventDefault();
        if (this.submitting || this.submitted) return;
        this.submitting = true;
        const button = this.querySelector('[data-quote-submit]');
        const label = button.querySelector('span');
        const initialLabel = label.textContent;
        const error = this.querySelector('[data-quote-error]');
        error.hidden = true;
        button.disabled = true;
        label.textContent = button.dataset.sendingLabel;
        const data = new FormData(this.form);
        const phone = String(data.get('contact[phone]') || '').trim();
        const phoneCode = String(data.get('contact[phone_country_code]') || '').trim();
        data.set('contact[phone]', phone.startsWith('+') ? phone : `${phoneCode} ${phone}`.trim());
        data.set('contact[name]', `${data.get('contact[first_name]')} ${data.get('contact[last_name]')}`.trim());
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        const variantId = productForm?.querySelector('[name="id"]')?.value;
        const quantity = productForm?.querySelector('[name="quantity"]')?.value || '1';
        const productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const variantOptions = [...(productInfo?.querySelectorAll('.product-parameters input[type="radio"]:checked, .product-parameters select') || [])].map(input => input.value).join(', ');
        data.set('contact[quantity]', quantity);
        data.set('contact[variant_id]', variantId || '');
        if (variantOptions) data.set('contact[variant]', variantOptions);
        data.set('contact[product_url]', this.dataset.productUrl + (variantId ? `?variant=${variantId}` : ''));
        if (!data.get('contact[body]')?.trim()) data.set('contact[body]', data.get('contact[subject]'));
        try {
          const response = await fetch(this.form.action, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' } });
          const responseURL = new URL(response.url, window.location.origin);
          if (responseURL.pathname.startsWith('/challenge')) {
            this.modal.hide();
            window.location.assign(response.url);
            return;
          }
          const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextForm = nextDocument.getElementById(this.form.id);
          const success = nextForm?.querySelector('[data-quote-success]');
          if (!response.ok || !success) throw new Error('Quote receipt was not confirmed');
          this.submitted = true;
          label.textContent = button.dataset.submittedLabel;
          button.classList.add('paloma-form-submit--submitted');
          this.querySelector('[data-quote-submit-status]').textContent = success.querySelector('p')?.textContent || button.dataset.submittedLabel;
        } catch (failure) {
          error.hidden = false;
          error.focus();
          button.disabled = false;
          label.textContent = initialLabel;
        } finally {
          this.submitting = false;
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sample-request-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sample-request')) {
    customElements.define(
      'product-sample-request',
      class extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
            return;
          }

          this.initialize();
        }

        initialize = () => {
          if (this.initialized) return;
          this.initialized = true;

          this.form = this.querySelector('form');
          this.materialsField = this.querySelector('[data-sample-materials-field]');
          this.materialsDetails = this.querySelector('.product-sample-request__multi-select');
          this.materialsSummary = this.querySelector('[data-materials-summary]');
          this.materialsSummaryText = this.querySelector('[data-materials-summary-text]');
          this.materialsClose = this.querySelector('[data-materials-close]');
          this.materialsOutput = this.querySelector('[data-materials-output]');
          this.materialsError = this.querySelector('[data-materials-error]');
          this.materialOptions = [...this.querySelectorAll('[data-material-option]')];
          this.submitButton = this.querySelector('[data-sample-request-submit]');
          this.submitButtonLabel = this.querySelector('[data-sample-request-submit-label]');
          this.phoneCountryCode = this.querySelector('[name="contact[phone_country_code]"]');
          this.phoneCountryCodeLabel = this.querySelector('[data-phone-country-code-label]');

          this.materialOptions.forEach((option) => option.addEventListener('change', this.updateMaterials));
          this.materialsClose?.addEventListener('click', this.closeMaterials);
          this.phoneCountryCode?.addEventListener('change', this.updatePhoneCountryCode);
          this.form?.addEventListener('submit', this.validateMaterials);
          this.updateMaterials();
          this.updatePhoneCountryCode();

          const result = this.querySelector('[data-sample-request-result]');
          if (!result) return;

          const popup = this.closest('.product-popup');
          const opener = popup?.querySelector('modal-opener button');

          window.requestAnimationFrame(() => {
            opener?.click();
            result.focus();
          });
        };

        disconnectedCallback() {
          document.removeEventListener('DOMContentLoaded', this.initialize);
          this.materialOptions?.forEach((option) => option.removeEventListener('change', this.updateMaterials));
          this.materialsClose?.removeEventListener('click', this.closeMaterials);
          this.phoneCountryCode?.removeEventListener('change', this.updatePhoneCountryCode);
          this.form?.removeEventListener('submit', this.validateMaterials);
        }

        updatePhoneCountryCode = () => {
          const selectedOption = this.phoneCountryCode?.selectedOptions?.[0];
          if (selectedOption && this.phoneCountryCodeLabel) {
            this.phoneCountryCodeLabel.textContent = selectedOption.textContent.trim();
          }
        };

        closeMaterials = () => {
          if (!this.materialsDetails) return;

          this.materialsDetails.open = false;
          this.materialsSummary?.focus();
        };

        updateMaterials = () => {
          const selected = this.materialOptions.filter((option) => option.checked).map((option) => option.value);

          if (this.materialsOutput) this.materialsOutput.value = selected.join(', ');

          if (this.materialsSummaryText && this.materialsSummary) {
            if (selected.length === 0) {
              this.materialsSummaryText.textContent = this.materialsSummary.dataset.emptyLabel;
            } else if (selected.length === 1) {
              this.materialsSummaryText.textContent = selected[0];
            } else {
              this.materialsSummaryText.textContent = `${selected.length} ${this.materialsSummary.dataset.selectedLabel}`;
            }
          }

          if (selected.length > 0) {
            if (this.materialsError) this.materialsError.hidden = true;
            this.materialsSummary?.setAttribute('aria-invalid', 'false');
          }
        };

        validateMaterials = (event) => {
          const hasSelection = this.materialOptions.some((option) => option.checked);
          if (hasSelection) {
            return;
          }

          event.preventDefault();
          this.materialsDetails.open = true;
          this.materialsError.hidden = false;
          this.materialsSummary?.setAttribute('aria-invalid', 'true');
          this.materialsSummary?.focus();
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
